import { useEffect, useRef } from 'react';

type UseInfiniteScrollOptions = {
  fetchNextPage: () => void;
  hasNextPage: boolean;
  isFetchingNextPage: boolean;
  /** IntersectionObserver threshold (0~1). 기본값 0.1 */
  threshold?: number;
};

/** @description 무한스크롤을 위한 IntersectionObserver 훅. sentinelRef를 리스트 하단에 배치하면 자동으로 다음 페이지를 요청한다. */
export const useInfiniteScroll = ({
  fetchNextPage,
  hasNextPage,
  isFetchingNextPage,
  threshold = 0.1,
}: UseInfiniteScrollOptions) => {
  const sentinelRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const sentinel = sentinelRef.current;
    if (!sentinel) return;

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && hasNextPage && !isFetchingNextPage) {
          fetchNextPage();
        }
      },
      { threshold }
    );

    observer.observe(sentinel);
    return () => observer.disconnect();
  }, [fetchNextPage, hasNextPage, isFetchingNextPage, threshold]);

  return { sentinelRef };
};
